<script>
  import {
    datagridStore,
    datagridFilterStore,
  } from "../../../stores/datagrid.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import { onDestroy } from "svelte";
  import get from "get-value";

  import { isObject } from "../../../helpers/functions";
  import { order } from "./datagrid.func";
  import Poi from "./tableItemPoi.svelte";
  import Link from "./tableItemLink.svelte";
  import Image from "./tableItemImage.svelte";
  import File from "./tableItemFile.svelte";
  import Icon from "../../../components/Icon/Icon.svelte";
  import Pagination from "./Pagination.svelte";

  let data = [];
  let zobrazPreloader = false;
  let unsubscribeDatagridStore = datagridStore.subscribe((store) => {
    data = get(store) || {};
  });

  onDestroy(unsubscribeDatagridStore);

  let filter = {};
  let unsubscribeDatagridFilterStore = datagridFilterStore.subscribe(
    (store) => {
      filter = get(store) || {};
    }
  );

  onDestroy(() => {
    unsubscribeDatagridFilterStore();
  });

  const components = {
    poi: Poi,
    link: Link,
    image: Image,
    file: File,
  };

  hooksStore.addAction(
    "zobrazDatagridTabulku",
    "Table.svelte",
    zobrazDatagridTabulku
  );

  function zobrazDatagridTabulku(zobraz) {
    zobrazPreloader = !zobraz;
  }
</script>

<!-- Splitter content start  -->
<div class="table__wrapper">
  {#if zobrazPreloader}
    <!-- Loading start -->
    <div class="loading js-loading">
      <span class="loading__loader">
        <span class="loading__loader-inner" />
      </span>
      <span class="loading__text">Dáta sa načítavajú</span>
    </div>
    <!-- Loading end  -->
  {:else}
    <!-- Table v2 start  -->
    <table class="table">
      {#if get(data, "columnNames")}
        <thead>
          <tr>
            {#each data.columnNames as column, i}
              <th class="table__sticky">
                <span on:click={() => order({ order: { column: i } })}>
                  {column.name.replace(`${data.type}_${data.tab}_`, "")}
                  {#if filter.post.order.column === i}
                    {#if filter.post.order.type === "asc"}
                      <Icon kod="027" />
                    {:else}
                      <Icon kod="028" />
                    {/if}
                  {/if}
                </span>
              </th>
            {/each}
          </tr>
        </thead>
      {/if}

      {#if get(data, "data") && data.data.length}
        <tbody>
          {#each get(data, "data") as row}
            <tr>
              {#if get(data, "columnNames")}
                {#each data.columnNames as column, i}
                  {@const item = get(
                    row,
                    column.systemName.replace(`${data.type}_${data.tab}_`, "")
                  )}
                  <td class={column.class}>
                    {#if item}
                      {#if isObject(item)}
                        <svelte:component
                          this={components[item.type]}
                          data={item}
                        />
                      {:else}
                        {item}
                      {/if}
                    {:else}
                      -
                    {/if}
                  </td>
                {/each}
              {/if}
            </tr>
          {/each}
        </tbody>
      {:else}
        <tbody>
          <tr
            ><td
              class="empty"
              colspan={data.columnNames ? data.columnNames.length : 1}
              >{get(data, "message") || "Neboli nájdené žiadne dáta."}</td
            ></tr
          >
        </tbody>
      {/if}
    </table>
    <!-- Table v2 end  -->
    <Pagination />
  {/if}
</div>

<!-- Pagination start  -->
<style lang="scss">
  .table__wrapper {
    flex-grow: 1;
  }
  .table tr td.empty:last-child {
    padding: 20px 0;
    text-align: center;
  }

  .loading {
    position: relative;
    margin: 0;
    flex-direction: column;
    background: #fff;
    padding: 20px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }
  .loading .loading__loader {
    margin: 20px auto;
    top: auto;
  }
  .loading .loading__text {
    position: relative;
    transform: none;
    top: auto;
    left: auto;
    text-align: center;
  }
</style>
